import Title from "../Title";
import Image from "next/image";
import Container from "../Container";
import {parallax} from "../../helpers/animations";
import {useEffect, useRef} from "react";


export default function SectionTiles({title, direction = 'right', images, children}) {
    const isLeft = direction === 'left';
    const isRight = !isLeft;


    const refImage1 = useRef();
    const refImage2 = useRef();
    const refImage3 = useRef();


    useEffect(() => {
        const parallaxOffsets = isLeft ? [0.17, 0.08, -0.05] : [0.01, -0.05, 0.08];

        const handleScroll = () => {
            if (window.innerWidth >= 1024) {
                if (refImage1.current) parallax(refImage1.current, parallaxOffsets[0]);
                if (refImage2.current) parallax(refImage2.current, parallaxOffsets[1]);
                if (refImage3.current) parallax(refImage3.current, parallaxOffsets[2]);
            }
        };

        window?.addEventListener('scroll', handleScroll);

        return () => window?.removeEventListener('scroll', handleScroll);
    }, [isLeft]);

    return (
        <Container className="pt-16 md:py-24">
            {isLeft && (
                <header className="mb-4 md:mb-9">
                    <Title>{title}</Title>
                </header>
            )}
            <div className="flex flex-col md:flex-row gap-2 md:gap-10 lg:gap-0">
                <div
                    className={`flex-1 flex-col gap-10 md:gap-20 ${isRight ? 'order-1 flex' : 'hidden md:flex order-2'}`}>
                    {isRight && (
                        <header>
                            <Title>{title}</Title>
                        </header>
                    )}

                    <div className="hidden md:flex flex-col gap-10 md:gap-20">
                        {images.desktop[0] && (
                            <div className={isRight ? 'pr-24' : 'pl-24'}>
                                <div className="w-full aspect-[5/6] relative ease-out transition-transform duration-500"
                                     ref={refImage1}>
                                    <Image
                                        src={images.desktop[0]}
                                        className="rounded-lg"
                                        alt=""
                                    />
                                </div>
                            </div>
                        )}

                        {images.desktop[1] && (
                            <div
                                className={`${isRight ? 'self-end' : ''}  w-full max-w-[370px] aspect-[18/13] relative ease-out transition-transform duration-500`}
                                ref={refImage2}
                            >
                                <Image
                                    src={images.desktop[1]}
                                    className="rounded-lg"
                                    alt=""
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`flex-1 flex flex-col gap-14 md:gap-24 ${isRight ? 'order-2' : 'order-1'}`}>

                    <div className="flex flex-col gap-6 max-w-[42ch]">
                        {children}
                    </div>

                    <div className="hidden md:block">
                        {images.desktop[2] && (
                            <div className={`${isRight ? 'pl-24' : 'pr-24'}`}>
                                <div className="w-full aspect-[5/4] relative ease-out transition-transform duration-500"
                                     ref={refImage3}>
                                    <Image
                                        src={images.desktop[2]}
                                        className="rounded-lg"
                                        alt=""
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="flex md:hidden flex-col text-0">
                        {images.mobile[0] && (
                            <div className="self-end pl-10 max-w-[400px] -mr-6 -mb-10 z-20">
                                <Image
                                    src={images.mobile[0]}
                                    className="rounded-lg  relative translate-x-4"
                                    alt=""
                                />
                            </div>
                        )}

                        {images.mobile[1] && (
                            <div className="pr-10 max-w-[400px] -ml-6 -mb-10 z-10">
                                <Image
                                    src={images.mobile[1]}
                                    className="rounded-lg  relative -translate-x-4"
                                    alt=""
                                />
                            </div>
                        )}

                        {images.mobile[2] && (
                            <div className="self-end pl-10 max-w-[400px] -mr-6">
                                <Image
                                    src={images.mobile[2]}
                                    className="rounded-lg  relative translate-x-4"
                                    alt=""
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </Container>
    )
}
